import * as React from "react";

import primaryColour from "../../constants";

function SvgRouting(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill = primaryColour } = props;
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" {...props} fill="none">
      <path d="M3.6355 16.9406H14.6226V8.2666" stroke={fill} strokeDasharray="3 3" />
      <path
        d="M4.63459 12.0072C4.63459 12.0569 4.61628 12.1711 4.55286 12.3639C4.49271 12.5469 4.4036 12.7665 4.29132 13.0132C4.06699 13.5061 3.76434 14.076 3.45675 14.622C3.16674 15.1368 2.8762 15.6236 2.65018 15.9942C2.42416 15.6236 2.13363 15.1368 1.84361 14.622C1.53602 14.076 1.23337 13.5061 1.00904 13.0132C0.896759 12.7665 0.807654 12.5469 0.747499 12.3639C0.684078 12.1711 0.665771 12.0569 0.665771 12.0072C0.665771 11.6719 0.84247 11.3334 1.19696 11.0626C1.55189 10.7914 2.06402 10.6094 2.65018 10.6094C3.23634 10.6094 3.74847 10.7914 4.1034 11.0626C4.45789 11.3334 4.63459 11.6719 4.63459 12.0072Z"
        stroke={fill}
      />
      <circle cx="2.65016" cy="11.9727" r="0.621102" fill={fill} />
      <path
        d="M16.7781 2.64781C16.7781 2.69749 16.7598 2.81171 16.6964 3.00456C16.6363 3.18748 16.5472 3.40716 16.4349 3.65385C16.2105 4.14672 15.9079 4.7166 15.6003 5.26262C15.3103 5.77744 15.0198 6.26425 14.7937 6.63486C14.5677 6.26425 14.2772 5.77744 13.9872 5.26262C13.6796 4.7166 13.3769 4.14672 13.1526 3.65385C13.0403 3.40716 12.9512 3.18748 12.8911 3.00456C12.8276 2.81171 12.8093 2.69749 12.8093 2.64781C12.8093 2.31248 12.986 1.97398 13.3405 1.70319C13.6954 1.43206 14.2076 1.25 14.7937 1.25C15.3799 1.25 15.892 1.43206 16.247 1.70319C16.6014 1.97398 16.7781 2.31248 16.7781 2.64781Z"
        stroke={fill}
      />
      <circle cx="14.7937" cy="2.61329" r="0.621102" fill={fill} />
    </svg>
  );
}

export default SvgRouting;
